import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgCalendarIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 10.2H4M15.5556 3v3.6M8.4444 3v3.6M8.2667 21h7.4666c1.4935 0 2.2402 0 2.8107-.2943a2.684 2.684 0 0 0 1.1654-1.1799C20 18.9482 20 18.1921 20 16.68V9.12c0-1.5121 0-2.2682-.2906-2.8458a2.684 2.684 0 0 0-1.1654-1.18C17.9735 4.8 17.2268 4.8 15.7333 4.8H8.2667c-1.4935 0-2.2402 0-2.8107.2943a2.684 2.684 0 0 0-1.1654 1.18C4 6.8517 4 7.6078 4 9.12v7.56c0 1.5121 0 2.2682.2907 2.8458.2556.508.6636.9211 1.1653 1.1799C6.0265 21 6.7732 21 8.2667 21"
    />
  </svg>
);
export default SvgCalendarIcon;
